import React, { Component } from 'react';
import Base from '../../rebase';
import PropTypes from 'prop-types';
import ImageCarousel from './ImageCarousel';
import Title from './Title';
import AgendaComponent from './AgendaComponent';
import ParagraphComponent from './ParagraphComponent';
import RSVPSection from './RSVP/RSVPSection';
import RSVPSummaryModal from './RSVP/RSVPSummaryModal';
import Logout from './Logout';
import MapComponent from './MapComponent';
import AttributedTextComponent from './Text/AttributedTextComponent';
import TextComponent from './Text/TextComponent';
import PageBreakComponent from './PageBreakComponent';
import SubTitle from './SubTitle';
import YouTubeComponent from './YouTubeComponent';

class PageComponent extends Component {

  render() {
    switch(this.props.component.componentName) {
      case 'ImageCarousel':
        return (<ImageCarousel items={this.props.component.items} />);
      case 'Title':
        return (<Title items={this.props.component.items} />);
      case 'SubTitle':
        return (<SubTitle style={this.props.component.style} title={this.props.component.title}/>);
      case 'AgendaComponent':
        return (<AgendaComponent items={this.props.component.items} style={this.props.component.style}/>);
      case 'ParagraphComponent':
        return (<ParagraphComponent items={this.props.component.items}/>);
      case 'RSVPSection':
        return (<RSVPSection items={this.props.component.items} title={this.props.component.title}/>);
      case 'Logout':
        return (<Logout logout={this.props.logout}/>);
      case 'MapComponent':
        return (<MapComponent />);
      case 'AttributedTextComponent':
        return (<AttributedTextComponent style={this.props.component.style} text={this.props.component.text}/>);
      case 'TextComponent':
        return (<TextComponent items={this.props.component.items} style={this.props.component.style}/>);
      case 'PageBreakComponent':
        return (<PageBreakComponent style={this.props.component.style}/>);
      case 'YouTubeComponent':
        return (<YouTubeComponent videoID={this.props.component.videoID}/>);
      case 'RSVPSummaryModal':
        return (<RSVPSummaryModal items={this.props.component.items}/>);
    }
  }
}

export default PageComponent;

PageComponent.propTypes = {
    component: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/PageComponent.jsx